import React, { FC } from "react";
import { LinearProgress } from "@evergis/ui";

import { DialogTitle } from "../DialogTitle";
import { DialogContextType, FullScreenDialog } from "../FullScreenDialog";
import { DialogContent, RestrictedWidthContainer } from "../styled";

type FullscreenFallbackProps = {
  context: DialogContextType;
};

export const FullscreenFallback: FC<FullscreenFallbackProps> = ({ context }) => (
  <FullScreenDialog dialogContext={context}>
    <DialogTitle />
    <DialogContent>
      <RestrictedWidthContainer>
        <LinearProgress />
      </RestrictedWidthContainer>
    </DialogContent>
  </FullScreenDialog>
);
